import React, { Component } from 'react';
import common from 'ui-react-common';
import _ from 'lodash';
import config from './../../../config';

const Select = common.ui.components.forms.Select;

export const validation = {
    validateOn: ['blur'],
    validationRegex: /.*/,
    required: true,
    message: {
        default: 'Please select an option',
    },
};

export const employmentStatuses = _.map(
    config.global.employmentStatuses,
    (i) => ({ text: i, value: i })
);

class EmploymentStatus extends Component {
    render() {
        return (
            <Select
                id="employmentStatus"
                name="employmentStatus"
                type="text"
                placeholder="Employment Status"
                usePlaceholderOption
                options={employmentStatuses}
                validation={validation}
                value={this.props.value}
            />
        );
    }
}

export default EmploymentStatus;
